module.exports = __webpack_public_path__ + "static/ronak_roy-a40138735e44e0f7b86af932ef597a95.jpg";